import { EffectivityManagement } from 'src/screens/shared/project/details/effectivity-management/EffectivityManagement'

export const PfKapEffectivityManagementPage = () => {
  return <EffectivityManagement baseUrl="/pf-kap" />
}
